import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";
import { camelCase, get } from "lodash-es";

import { CoreState } from "../../state";

import { ACTION_PREFIX } from "./deposit-limit.action";
import { DepositLimit, DepositLimits, DepositLimitType } from "./deposit-limit.model";
import { MultiDepositLimit, MultiDepositLimits } from "./multi-deposit-limit/multi-deposit-limit.model";

/**
 * @deprecated [fabric-deprecated] - Use DepositLimitService from app-responsible-gaming instead
 */
@Injectable({
	providedIn: "root",
})
export class DepositLimitSelector {
	isBusy() {
		return (state: CoreState): boolean => FetchStatusSelector.isStatus(ACTION_PREFIX)(state);
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetAllDepositLimits instead
	 */
	getAll() {
		return (state: CoreState): DepositLimits | MultiDepositLimits | undefined => state.depositLimit.depositLimits;
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetAllDepositLimits instead
	 */
	get(depositLimitType: DepositLimitType) {
		return (state: CoreState): DepositLimit | undefined =>
			state.depositLimit.depositLimits && state.depositLimit.depositLimits[camelCase(depositLimitType)];
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetUnconfirmedDepositLimits instead
	 */
	getAllUnconfirmed() {
		return (state: CoreState): DepositLimits | MultiDepositLimit | undefined =>
			state.depositLimit.depositLimitsUnconfirmed;
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetUnconfirmedDepositLimits instead
	 */
	getUnconfirmed(depositLimitType: DepositLimitType) {
		return (state: CoreState): DepositLimit =>
			get(state.depositLimit, `depositLimitsUnconfirmed.${camelCase(depositLimitType)}`) as DepositLimit;
	}
}
